(function () {
  var el = document.querySelector('[data-trm-title-en]');
  if (!el || !window.fetch) return;
  var h1 = document.querySelector('.productView-title span');
  var current = (h1 ? h1.textContent : '').replace(/\s+/g, ' ').trim();
  var started = performance.now();
  fetch(el.getAttribute('data-trm-title-en'), { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (json) {
      if (!json || !json.title) return;
      var en = String(json.title).replace(/\s+/g, ' ').trim();
      if (en && en !== current) { el.textContent = en; el.hidden = false; }
      el.setAttribute('data-trm-ms', String(Math.round(performance.now() - started)));
    })
    .catch(function () {});
})();
